import { SET_BLOCKS_DATA, SET_BLOCK_INFO, SET_BLOCK_TRANSACTIONS } from './constants';
import { BlocksReducer, BlocksActions } from './types';

const initState: BlocksReducer = {
  blocks: [],
  transactions: [],
  blockInfo: null,
};

export default (state = initState, action: BlocksActions): BlocksReducer => {
  switch (action.type) {
    case SET_BLOCKS_DATA:
      return {
        ...state,
        blocks: action.payload,
      };
    case SET_BLOCK_TRANSACTIONS:
      return {
        ...state,
        transactions: action.payload,
      };
    case SET_BLOCK_INFO:
      return {
        ...state,
        blockInfo: action.payload,
      };
    default:
      return state;
  }
};
